import { render, staticRenderFns } from "./SupplierMealWrapper.vue?vue&type=template&id=21f61bf2"
import script from "./SupplierMealWrapper.vue?vue&type=script&lang=js"
export * from "./SupplierMealWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports